import { cn } from '@/lib/utils'
import { HISTORY_STATE_LABELS, HISTORY_STATE_STYLES } from '@/lib/history'
import type { HistoryState } from '@/api/types'

const badgeBaseClass = 'inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium'

export function HistoryStateBadge({ state }: { state: HistoryState }): React.ReactElement {
  return <span className={cn(badgeBaseClass, HISTORY_STATE_STYLES[state])}>{HISTORY_STATE_LABELS[state]}</span>
}
